import { useMemo, useState } from 'react';

import { useRecoilState } from 'recoil';

import { PlanUnitMix } from 'components/types';

import { planUnitsAtom } from '../../atoms';

import { Box } from '@mui/material';

import PlanUnitSelector from 'components/shared/PlanUnitSelector';
import YearQuarterNavigation from 'components/shared/YearQuarterNavigation';

import ScenarioActions from './ScenarioActions';
import ScenarioSelect from './ScenarioSelect';

const ScenarioBar = () => {
  const [selectedPlanUnits, setSelectedPlanUnits] =
    useRecoilState(planUnitsAtom);
  const [lastSavedScenarioId, setLastSavedScenarioId] = useState<number | null>(
    null
  );

  const onSelectPlanUnit = (options: PlanUnitMix[]) => {
    const planunits = options.flatMap((o) =>
      'costCenters' in o ? o.costCenters : o
    );

    setSelectedPlanUnits(planunits);
  };

  const onSaveScenario = (scenarioId) => {
    setLastSavedScenarioId(scenarioId);
  };

  const selectedPlanUnitIds = useMemo(
    () => selectedPlanUnits.map(({ id }) => id),
    [selectedPlanUnits]
  );

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      position="relative"
      p={2}
    >
      <PlanUnitSelector onSelected={onSelectPlanUnit} />
      <Box
        position="absolute"
        mx="auto"
        left="50%"
        sx={{ transform: 'translateX(-50%)' }}
        mt={1}
      >
        <YearQuarterNavigation />
      </Box>
      <Box display="flex" alignItems="end">
        <ScenarioSelect
          planUnitIds={selectedPlanUnitIds}
          lastSavedScenarioId={lastSavedScenarioId}
        />
        <ScenarioActions onSaveScenario={onSaveScenario} />
      </Box>
    </Box>
  );
};

export default ScenarioBar;
